import React from 'react';

import FormRecurringMeetingsSelection from 'Shared/components/FormComponents/FormRecurringMeetingsSelection';
import { WorkspaceType } from 'Shared/constants/types';

function FormFields() {
  return (
    <div className="my-3">
      <FormRecurringMeetingsSelection selector="recurringMeetings" type={WorkspaceType.isGroup} mobileVersion />
    </div>
  );
}

export default FormFields;
